import { Box, createStyles, makeStyles } from "@material-ui/core";

import { darken } from "@material-ui/core/styles";
import styled from "styled-components";

import { IExtendedTheme } from "../../theme/default";

export const useStyles = makeStyles((t: IExtendedTheme) =>
	createStyles({
		indicator: {
			display: "none"
		},
		tab: {
			minWidth: 144,
			fontFamily: "var(--poppins)",
			color: t.palette.primary.text,
			background: t.palette.primary.light,
			fontWeight: 700,
			fontSize: 12,
			textTransform: "none"
		},
		tabSelected: {
			color: t.palette.primary.tabs.contrastText,
			background: t.palette.primary.dark,

			"&:first-child": {
				borderRadius: "3px 0 0 3px"
			},
			"&:last-child": {
				borderRadius: "0 3px 3px 0"
			}
		},
		titleText: {
			fontWeight: 700,
			fontSize: 16,
			textAlign: "start"
		},
		marAsReadText: {
			fontWeight: 600,
			fontSize: 12,
			textDecoration: "underline",
			color: t.palette.colors.info[400],
			cursor: "pointer"
		},
		notificationWrapper: {
			position: "absolute",
			width: "480px",
			top: "55px",
			right: "-137px",
			borderRadius: "4px",
			background: t.palette.background.paper,
			boxShadow: "0 0 12px rgba(27,31,35,.15)",
			padding: 24
		},
		notificationBlock: {
			height: "100%",
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			padding: "14px 10px",
			lineHeight: "1.4",
			"&:not(:last-child)": {
				borderBottom: "1px solid hsl(223, 14%, 26%)"
			},
			"&:hover": {
				background: darken(t.palette.background.paper, 0.1)
			}
		},
		notificationTitle: {
			fontFamily: "var(--openSans)",
			fontWeight: 600,
			opacity: 0.87,
			fontSize: 13
		},
		notificationBody: {
			fontFamily: "var(--openSans)",
			fontWeight: 600,
			opacity: 0.87,
			fontSize: 13
		},
		notificationDate: {
			fontFamily: "var(--openSans)",
			fontWeight: 500,
			opacity: 0.87,
			fontSize: 10,
			color: t.palette.colors.basic[300]
		},
		markerIcon: {
			width: 10,
			height: 10,
			borderRadius: "50%",
			background: t.palette.colors.primary[500]
		}
	})
);

export const ToastWrapper = styled(Box)`
	width: 100%;
	.Toastify__toast {
		background: ${({ theme }) => theme.palette.background.paper} !important;
		padding: 0;
	}
	.Toastify__toast-container:has(div.wide) {
		width: 450px;
		${({ theme }) => theme.breakpoints.down("sm")} {
			width: 100vw;
		}
	}
	.Toastify__close-button {
		color: ${({ theme }) => theme.palette.text.primary} !important;
		position: absolute;
		right: 10px;
		top: 10px;
	}
	.Toastify__toast-body {
		padding: 0 !important;
		cursor: default;
		width: 100%;
	}
`;

export const AnnouncementWrapper = styled(Box)`
	display: flex;
	flex-direction: column;

	.react-multi-carousel-track {
		width: 312px !important;
		li {
			width: 312px !important;
		}
		${({ theme }) => theme.breakpoints.down("sm")} {
			width: 100vw !important;
			li {
				width: 100vw !important;
			}
		}
	}
	.react-multi-carousel-dot-list {
		justify-self: flex-start;
		margin-bottom: 10px;
		margin-left: 25px;
	}
	.react-multiple-carousel__arrow--left {
		left: 10px;
		bottom: 35px;
		right: unset;
		top: unset;
		background: unset;
	}
	.react-multiple-carousel__arrow--right {
		left: 45px;
		bottom: 35px;
		right: unset;
		top: unset;
		background: unset;
	}
	.carousel-item {
		width: 312px;
		${({ theme }) => theme.breakpoints.down("sm")} {
			width: 100vw !important;
		}
	}
	p {
		color: ${({ theme }) => theme.palette.text.primary};
	}

	.body {
		padding-left: 24px;
		padding-right: 24px;
		min-height: 180px;
		word-wrap: break-word;
		p:first-child {
			font-family: var(--poppins);
			font-weight: 700;
			font-size: 18px;
			margin-top: 5px;
			margin-bottom: 5px;
		}
		p:last-child {
			font-family: var(--openSans);
			font-weight: 400;
			font-size: 13px;
		}
	}

	.action {
		display: flex;
		justify-content: flex-end;
		height: 100px;
		align-items: center;
		padding: 10px;
	}
`;

export const PushWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	p {
		color: ${({ theme }) => theme.palette.text.primary};
	}

	.body {
		padding-left: 24px;
		padding-right: 24px;
		p:first-child {
			font-family: var(--openSans);
			font-weight: 600;
			font-size: 15px;
			margin-top: 5px;
			margin-bottom: 5px;
		}
		p:last-child {
			font-family: var(--openSans);
			font-weight: 400;
			font-size: 15px;
			color: ${({ theme }) => theme.palette.text.secondary};
		}
	}
`;
